import React, { FC, useId } from 'react';
import { InputLabel, Input } from '@mui/material';
import styles from './styles.module.sass';

type Properties = {
  onFilterQuery: (query: string) => void;
};
export const ListFilter: FC<Properties> = ({ onFilterQuery }) => {
  const id = useId();

  return (
    <div className={styles.container}>
      <InputLabel className={styles.label} htmlFor={id}>
        Filter by name:
      </InputLabel>
      <Input className={styles.input} onChange={(e) => onFilterQuery(e.target.value)} id={id}></Input>
    </div>
  );
};
